/**
 * Sends form data to a Discord webhook
 * @param webhookUrl - The Discord webhook URL
 * @param formData - The form data to send
 * @returns Promise that resolves when the request is complete
 */
export const sendToDiscordWebhook = async (webhookUrl: string, formData: Record<string, string>): Promise<Response> => {
  const content = Object.entries(formData)
    .map(([key, value]) => `**${key}**: ${value}`)
    .join('\n');

  const payload = {
    content,
    username: 'Contact Form Bot',
  };

  return fetch(webhookUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};